function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.164 20.361h-3.476L27.899 2.249a3.238 3.238 0 00-6.184.038l-4.9 20.111a.367.367 0 01-.706.035l-4.187-12.164a3.189 3.189 0 00-2.767-2.326 3.229 3.229 0 00-3.212 1.7L.378 20.338a3.3 3.3 0 001.105 4.283 3.146 3.146 0 004.508-1.207l2.417-4.57 5.116 16.5a3.236 3.236 0 006.209.068l5.566-20.859 2.88 9.778a3.19 3.19 0 003.085 2.256h5.9a3.113 3.113 0 100-6.226z",
  fillRule: "evenodd"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 40.375 37.688"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/pulse.9cd5f68a.svg";
export { SvgComponent as ReactComponent };